/*
 * escaping a string for regex Utility function
 * from https://stackoverflow.com/questions/3446170/escape-string-for-use-in-javascript-regex
 */
function escapeRegExp (str) {
  return str.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
}

module.exports = escapeRegExp;



//////////////////
// WEBPACK FOOTER
// ./~/leaflet-geocoder-mapzen/src/utils/escapeRegExp.js
// module id = 194
// module chunks = 0